const AppRoute = {
  MAIN: '/',
  STOCK: '/stock',
  RESOURCES: '/resources',
  EARN: '/earn',
  PARTNERS: '/partners',
  RATING: '/rating',
  SETTINGS: '/settings',
  MATERIALS: '/materials',
  PRODUCTS: '/products',
  FRIENDS: '/friends',
  FACTORY: '/factory',
  WORKSHOP: '/workshop',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  LEAGUES: '/leagues',
  PRESENTATION: '/presentation',
  ERRORPAGE: '/errorPage',
  MAINTENANCE: '/maintenance',
  SHOP: '/shop',
  DICE_GAME: '/dice-game',
  LOGIN: '/login',
  AUTH_CALLBACK: '/auth/callback',
  NOTIFICATIONS: '/notifications',
  LOTTERY: '/lottery',
  BINGO: '/bingo',
  BINGO_LEADERBOARD: '/bingo/leaderboard',
  GAME_CENTER: '/game-center',
  SCRATCH: '/scratch',
} as const;

export { AppRoute };
